module.exports = __webpack_public_path__ + "img/user.6a6e6db9.png";